import TIML from '../../../framework/timl.js';
import { ShowPage } from '../crud/shared.js';

class BrandDetails {
  static timl = `
    table.details-table
      tbody
        tr
          th Name
          td {{ item.name }}
        tr
          th Slug
          td {{ item.slug }}
        tr
          th Domain
          td {{ item.domain }}
        tr
          th Description
          td {{ item.description }}
        tr
          th Logo URL
          td {{ item.logoUrl }}
        tr
          th Primary Color
          td {{ item.primaryColor }}
        tr
          th Support Email
          td {{ item.supportEmail }}
        tr
          th Status
          td {{ item.status }}
        tr
          th Account ID
          td {{ item.accountId }}
        tr
          th Created At
          td {{ item.createdAt }}
        tr
          th Updated At
          td {{ item.updatedAt }}
        tr
          th Created By
          td {{ item.createdBy }}
        tr
          th Updated By
          td {{ item.updatedBy }}
  `;
}

export class BrandsShow extends ShowPage {
  static timl = `
    a#share-button.list-view-add-button.float-right[href="/brands/{{ Routing.params.id }}/edit"] Edit
    <Breadcrumbs title="Brands" href="/brands" nameHref="/brands/{{ Routing.params.id }}" nameStyle="" nameSeparatorStyle="" suffix="" suffixStyle="display:none;" suffixSeparatorStyle="display:none;">
    div#brand-details.mt-15 Loading...
  `;

  static mapItemToViewModel(item) {
    return {
      item: {
        name: item.name || '—',
        slug: item.slug || '—',
        domain: item.domain || '—',
        description: item.description || '—',
        logoUrl: item.logoUrl || '—',
        primaryColor: item.primaryColor || '—',
        supportEmail: item.supportEmail || '—',
        status: item.status || '—',
        accountId: item.accountId || '—',
        createdAt: Util.formatDate(item.createdAt) || '—',
        updatedAt: Util.formatDate(item.updatedAt) || '—',
        createdBy: item.createdBy || '—',
        updatedBy: item.updatedBy || '—'
      }
    };
  }

  static javascript() {
    super.javascript();

    API.get(API.resourceUrl('brands', Routing.params.id))
      .then(data => {
        const viewModel = this.mapItemToViewModel(data.data);
        document.querySelector('#name').innerText = viewModel.item.name;
        TIML.renderInto(document.querySelector('#brand-details'), BrandDetails, viewModel);
      });
  }
}
